<div class="">

  <div style="min-height: 50%;">

    <tabset class="p-0 m-0">

      <tab *ngFor="let t of tabs; let i=index"
        [active]="t.active"
        [heading]=""
        (selectTab)="onTabChange(t,true)"
        (deselect)="onTabChange(t,false)"
        [disabled]="t.disabled"
        [removable]="false">
        <ng-template tabHeading>
          <span>{{t.viewInfo.title|async}}</span>&nbsp;
          <span *ngIf="t.closable" (click)="$event.preventDefault(); removeTab(i)" class="bs-remove-tab"><i class="fa fa-times"></i></span>
        </ng-template>
        <div [ngSwitch]="t.viewInfo.viewType" class="p-2 h-100 tab-content">
          <div *ngSwitchCase="'home'" class="h-100">
            <!-- this tab has no state so completely remove it with ngIf when not the focused tab-->
            <app-home-tab *ngIf="t.active" [detailFn]='showDetails' [tabConfig]="t"></app-home-tab>
          </div>
          <div *ngSwitchCase="'task list'" class="h-100">
            <app-task-list [detailFn]='showDetails' [tabConfig]="t"
              [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)">
            </app-task-list>
          </div>
          <div *ngSwitchCase="'user list'" class="h-100">
            <app-user-list [tabConfig]="t"></app-user-list>
          </div>
          <div *ngSwitchCase="'volunteer list'" class="h-100">
            <app-volunteer-list [tabConfig]="t"></app-volunteer-list>
          </div>

          <div *ngSwitchCase="'building status'" class="h-100">
            <app-scout-list [detailFn]='showDetails' [tabConfig]="t"></app-scout-list>
          </div>
          <div *ngSwitchCase="'path status'" class="h-100">
            <app-path-list [tabConfig]="t"></app-path-list>
          </div>
          <div *ngSwitchCase="'path test'" class="h-100">
            <app-path-test [pathTest]="{id: t.viewInfo.id, doc: $any(t.viewInfo.task)}"
            [tabConfig]="t" (contextJsonChange)="updateUrlItemId($event,t)">
          </app-path-test>
          </div>
          <div *ngSwitchCase="'drive test'" class="h-100">
            <app-path-test [driveTest]="{id: t.viewInfo.id, doc: $any(t.viewInfo.task)}"
            [tabConfig]="t" (contextJsonChange)="updateUrlItemId($event,t)"></app-path-test>
          </div>
          <div *ngSwitchCase="'path test group'" class="h-100">
            <app-path-test-group [groupCriteriaJson]="t.viewInfo.id" [tabConfig]="t"></app-path-test-group>
          </div>
          <div *ngSwitchCase="'drive test group'" class="h-100">
            <app-path-test-group [groupCriteriaJson]="t.viewInfo.id" [tabConfig]="t"></app-path-test-group>
          </div>
          <div *ngSwitchCase="'scout task'" class="h-100">
            <app-scout-view [scoutTask]="$any(t.viewInfo.task)" [tabConfig]="t" [detailFn]='showDetails'></app-scout-view>
          </div>
          <div *ngSwitchCase="'volunteer task'" class="h-100">
            <app-volunteer-task [taskId]="t.viewInfo.id" [tabConfig]="t" [detailFn]='showDetails'
            (contextJsonChange)="updateUrlItemId($event,t)"></app-volunteer-task>
          </div>
          <div *ngSwitchCase="'schedule task'" class="h-100">
            <app-task-schedule [task]="t.viewInfo.task" [tabConfig]="t"></app-task-schedule>
          </div>
          <div *ngSwitchCase="'building'" class="h-100">
            <app-building-view [buildingId]="t.viewInfo.id" [tabConfig]="t"></app-building-view>
          </div>
          <div *ngSwitchCase="'point'" class="h-100">
            <app-point-view *ngIf="t.active" [pointId]="t.viewInfo.id"></app-point-view>
          </div>
          <div *ngSwitchCase="'path'" class="h-100">
            <app-path-view [tabConfig]="t" [contextJson]="t.viewInfo.id"></app-path-view>
          </div>
          <div *ngSwitchCase="'scout path'" class="h-100">
            <app-scout-path-editor [scoutTaskDoc]="$any(t.viewInfo.task)" [scoutPathId]="t.viewInfo.id"
              [tabConfig]="t" [detailFn]='showDetails'
              (contextJsonChange)="updateUrlItemId($event,t)"></app-scout-path-editor>
          </div>
          <div *ngSwitchCase="'scout report'" class="h-100">
            <app-scout-path-report [scoutTaskDoc]="$any(t.viewInfo.task)" [scoutPathId]="t.viewInfo.id"
              [tabConfig]="t" [detailFn]='showDetails'></app-scout-path-report>
          </div>
          <div *ngSwitchCase="'scout data report'" class="h-100">
            <app-scout-path-entry-report [scoutTaskDoc]="$any(t.viewInfo.task)" [contextJson]="t.viewInfo.id"
              [tabConfig]="t" [detailFn]="showDetails"
              (contextJsonChange)="updateUrlItemId($event,t)"></app-scout-path-entry-report>
          </div>
          <div *ngSwitchCase="'correlation dashboard'" class="h-100">
            <app-correlation-dashboard [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active"
            [contextJson]="t.viewInfo.id"
            [contextJsonChangeHandler]="updateUrlItemId">
            </app-correlation-dashboard>
          </div>
          <div *ngSwitchCase="'correlation summary'" class="h-100">
            <app-correlation-summary
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)"></app-correlation-summary>
          </div>
          <div *ngSwitchCase="'file import'" class="h-100">
            <app-import-file-panel
              [tabConfig]="t" [detailFn]='showDetails'></app-import-file-panel>
          </div>
          <div *ngSwitchCase="'location logs'" class="h-100">
            <ng-template #locLogsCellRendererTmpl let-record="record" let-column="column" let-showRequestFn="showRequestFn">
              <td fes-loc-logs-table-cell-renderer [record]="record" [column]="column" (showRequest)="showRequestFn($event)">
              </td>
            </ng-template>
            <app-location-logs [cellRendererTmplRef]="locLogsCellRendererTmpl"
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)"></app-location-logs>
          </div>
          <div *ngSwitchCase="'call logs'" class="h-100">
            <ng-template #callLogsCellRendererTmpl let-record="record" let-column="column" let-tableComponent="tableComponent" let-showRequestFn="showRequestFn">
              <td fes-call-logs-table-cell-renderer [record]="record" [column]="column" [tableComponent]="tableComponent" (showRequest)="showRequestFn($event)">
              </td>
            </ng-template>
            <app-call-logs [cellRendererTmplRef]="callLogsCellRendererTmpl"
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)"></app-call-logs>
          </div>
          <div *ngSwitchCase="'handsets'" class="h-100">
            <ng-template #handsetCellRendererTmpl let-record="record" let-column="column" let-showRequestFn="showRequestFn">
              <td fes-handset-table-cell-renderer [record]="record" [column]="column" (showRequest)="showRequestFn($event)">
              </td>
            </ng-template>
            <app-handset-table [cellRendererTmplRef]="handsetCellRendererTmpl" #handsetTable
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)">
              &nbsp;
              <i role="button" class="fa fa-question my-auto px-sm-1 text-muted"
                title="Find phones in call logs not in handset inventory"
                (click)="handsetTable.showMissing()">
              </i>
            </app-handset-table>
          </div>
          <div *ngSwitchCase="'missing handsets'" class="h-100">
            <ng-template #missingHandsetCellRendererTmpl let-record="record" let-column="column" let-showRequestFn="showRequestFn">
              <td fes-missing-handset-table-cell-renderer [record]="record" [column]="column" (showRequest)="showRequestFn($event)">
              </td>
            </ng-template>
            <app-missing-handset-table [cellRendererTmplRef]="missingHandsetCellRendererTmpl"
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)"></app-missing-handset-table>
          </div>
          <div *ngSwitchCase="'dialer call logs'" class="h-100">
            <app-dialer-call-logs
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              [contextJsonChangeHandler]="updateUrlItemId"></app-dialer-call-logs>
          </div>
          <div *ngSwitchCase="'rut call logs'" class="h-100">
            <app-rut-call-log
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              [contextJsonChangeHandler]="updateUrlItemId"></app-rut-call-log>
          </div>

          <div *ngSwitchCase="'t-mobile location logs'" class="h-100">
            <ng-template #tmoLocLogsCellRendererTmpl let-record="record" let-column="column" let-showRequestFn="showRequestFn">
              <td fes-tmo-loc-logs-table-cell-renderer [record]="record" [column]="column" (showRequest)="showRequestFn($event)">
              </td>
            </ng-template>
            <app-tmo-location-logs [cellRendererTmplRef]="tmoLocLogsCellRendererTmpl"
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)"></app-tmo-location-logs>
          </div>
          <div *ngSwitchCase="'correlation'" class="h-100">
            <ng-template #correlationCellRendererTmpl let-record="record" let-column="column" let-tableComponent="tableComponent" let-showRequestFn="showRequestFn">
              <td fes-correlation-table-cell-renderer [record]="record" [column]="column" [tableComponent]="tableComponent" (showRequest)="showRequestFn($event)">
              </td>
            </ng-template>
            <app-correlation-table [cellRendererTmplRef]="correlationCellRendererTmpl"
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              (contextJsonChange)="updateUrlItemId($event,t)"
              [hideCellRenderer]="correlationTable.records?.length>500"
              #correlationTable
            >
              <div class="d-flex">
                <button class="btn btn-sm btn-secondary mx-1 small" (click)="correlationTable.showKmlViewer()"
                    [disabled]="correlationTable.showingKmlViewer">
                  <i class="fa {{correlationTable.showingKmlViewer?'fa-spinner fa-spin':'fa-globe'}}"></i> KML
                </button>
              </div>
              <!-- use a very basic rendering of rows for large page sizes for performance -->
              <ng-container tbody *ngIf="correlationTable.records?.length>500">
                <tr *ngFor="let record of correlationTable.records">
                  <ng-container *ngFor="let column of correlationTable.visibleColumns">
                  <td>{{record[column.name]}}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </app-correlation-table>
          </div>
          <div *ngSwitchCase="'dialer config'" class="h-100">
            <app-dialer-client-config [tabConfig]="t"></app-dialer-client-config>
          </div>

          <div *ngSwitchCase="'rxdb points'" class="h-100">
            <app-rxdb-points-view *ngIf="t.active"></app-rxdb-points-view>
          </div>
          <div *ngSwitchCase="'markets'" class="h-100">
            <app-rxdb-markets-view *ngIf="t.active"></app-rxdb-markets-view>
          </div>
          <div *ngSwitchCase="'rxdb buildings'" class="h-100">
            <app-rxdb-buildings-view *ngIf="t.active"></app-rxdb-buildings-view>
          </div>
          <div *ngSwitchCase="'rxdb paths'" class="h-100">
            <app-rxdb-paths-view *ngIf="t.active"></app-rxdb-paths-view>
          </div>
          <div *ngSwitchCase="'rxdb waypoints'" class="h-100">
            <app-rxdb-waypoints-view *ngIf="t.active"></app-rxdb-waypoints-view>
          </div>
          <div *ngSwitchCase="'points audit'" class="h-100">
            <app-point-audit [detailFn]='showDetails' [tabConfig]="t"></app-point-audit>
          </div>
          <div *ngSwitchCase="'volunteer tasks'" class="h-100">
            <app-volunteer-task-list [tabConfig]="t" [detailFn]='showDetails'
            [contextJson]="t.viewInfo.id" [contextJsonChangeHandler]="updateUrlItemId"></app-volunteer-task-list>
          </div>
          <div *ngSwitchCase="'volunteer handsets'" class="h-100">
            <app-volunteer-handset-list [tabConfig]="t" [detailFn]='showDetails'
            [contextJson]="t.viewInfo.id" [contextJsonChangeHandler]="updateUrlItemId"></app-volunteer-handset-list>
          </div>
          <div *ngSwitchCase="'volunteer points'" class="h-100">
            <app-volunteer-point-list [tabConfig]="t" [detailFn]='showDetails'
            [contextJson]="t.viewInfo.id" [contextJsonChangeHandler]="updateUrlItemId"></app-volunteer-point-list>
          </div>
          <div *ngSwitchCase="'volunteer task points'" class="h-100">
            <app-volunteer-task-points [tabConfig]="t"
            [contextJson]="t.viewInfo.id" [contextJsonChangeHandler]="updateUrlItemId"></app-volunteer-task-points>
          </div>
          <div *ngSwitchCase="'event log'" class="h-100">
            <app-event-log
              [tabConfig]="t" [detailFn]='showDetails' [isActiveView]="t.active" [contextJson]="t.viewInfo.id"
              [contextJsonChangeHandler]="updateUrlItemId"></app-event-log>
          </div>
          <div *ngSwitchDefault class="card m-2 p-2">
            <h3 class="text-danger">Unsupported view type "{{t.viewInfo.viewType}}"</h3>
          </div>
        </div>
      </tab>

    </tabset>

  </div>

  <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>

</div>
<div class="mb-4">&nbsp;<!--TODO - better way to make sure status bar doesn't cover content above it when scrolling--></div>
<app-status-bar [hasUnsavedDataFn]="hasUnsavedData"></app-status-bar>
